/**
 * Main JavaScript Entry Point
 */
import { Navigation } from './modules/navigation.js';
import { ReservationForm } from './modules/reservation-form.js';

document.addEventListener('DOMContentLoaded', () => {
    // Initialize navigation
    new Navigation('.site-header');

    // Initialize reservation form (if present)
    new ReservationForm('#reservation-form');

    // Floating Buttons Visibility (WhatsApp & Back to Top)
    const whatsappBtn = document.querySelector('.whatsapp-sticky');
    const backToTopBtn = document.querySelector('.back-to-top');

    if (whatsappBtn || backToTopBtn) {
        const toggleButtonsVisibility = () => {
            const isVisible = window.scrollY > 300;
            if (whatsappBtn) {
                whatsappBtn.classList.toggle('is-visible', isVisible);
            }
            if (backToTopBtn) {
                backToTopBtn.classList.toggle('is-visible', isVisible);
            }
        };

        window.addEventListener('scroll', toggleButtonsVisibility);
        toggleButtonsVisibility(); // Check on load
    }

    // Back to Top Click
    if (backToTopBtn) {
        backToTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});
